module.exports = __webpack_public_path__ + "static/media/snow-bg.8146047f.svg";